import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Search } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useData } from '../contexts/DataContext';
import CaregiverCard from '../components/CaregiverCard';
import AnimatedEmptyState from '../components/ui/AnimatedEmptyState';

const SavedCaregivers = () => {
  const { favoriteCaregivers } = useAuth();
  const { caregivers } = useData();

  const saved = (caregivers || []).filter((caregiver) =>
    favoriteCaregivers.includes(caregiver.id)
  );

  // A favorite can outlive the caregiver profile it points at
  const missingCount = favoriteCaregivers.length - saved.length;

  return (
    <div className="pf-page-wrap pb-32 lg:pb-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-8">
          <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-2 flex items-center gap-3">
            <Heart className="w-8 h-8 fill-red-500 text-red-500" />
            Saved Caregivers
          </h1>
          <p className="text-gray-600">
            {saved.length > 0
              ? `${saved.length} caregiver${saved.length !== 1 ? 's' : ''} you've saved for later`
              : 'Caregivers you save will appear here'}
          </p>
        </div>

        {saved.length > 0 ? (
          <>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {saved.map((caregiver) => (
                <CaregiverCard key={caregiver.id} caregiver={caregiver} />
              ))}
            </div>
            {missingCount > 0 && (
              <p className="mt-6 text-sm text-gray-500">
                {missingCount} saved caregiver{missingCount !== 1 ? 's are' : ' is'} no longer
                available on the platform.
              </p>
            )}
          </>
        ) : (
          <div className="pf-organic-card py-12">
            <AnimatedEmptyState
              icon="loader-running-dog"
              title="No saved caregivers yet"
              description="Tap the heart on any caregiver to save them here for quick access."
              action={
                <Link to="/search" className="pf-btn-primary inline-flex items-center gap-2">
                  <Search className="w-4 h-4" />
                  Find Caregivers
                </Link>
              }
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default SavedCaregivers;
